import { PublicClientApplication } from '@azure/msal-browser';
import { env } from '@sib/config';

const msalMicrositesInstance = new PublicClientApplication({
  auth: {
    clientId: env.spendbrainClientId || '',
    authority: `https://login.microsoftonline.com/${env.spendbrainTenantId}`,
    redirectUri: `${window.location.origin}/login`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    // Ref: https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/4206
    tokenRenewalOffsetSeconds: 35 * 60,
  },
});

const msalExtensionInstance = new PublicClientApplication({
  auth: {
    clientId: env.extensionClientId || '',
    authority: `https://login.microsoftonline.com/${env.extensionTenantId}`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    // Ref: https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/4206
    tokenRenewalOffsetSeconds: 35 * 60,
  },
});

export const msalInstance = env.isExtension
  ? msalExtensionInstance
  : msalMicrositesInstance;
